var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.49805H8V13.498C8 13.7633 7.89464 14.0176 7.70711 14.2052C7.51957 14.3927 7.26522 14.498 7 14.498C6.73478 14.498 6.48043 14.3927 6.29289 14.2052C6.10536 14.0176 6 13.7633 6 13.498V8.49805H1C0.734784 8.49805 0.48043 8.39269 0.292893 8.20515C0.105357 8.01762 0 7.76326 0 7.49805C0 7.23283 0.105357 6.97848 0.292893 6.79094C0.48043 6.6034 0.734784 6.49805 1 6.49805H6V1.49805C6 1.23283 6.10536 0.978476 6.29289 0.79094C6.48043 0.603403 6.73478 0.498047 7 0.498047C7.26522 0.498047 7.51957 0.603403 7.70711 0.79094C7.89464 0.978476 8 1.23283 8 1.49805V6.49805H13C13.2652 6.49805 13.5196 6.6034 13.7071 6.79094C13.8946 6.97848 14 7.23283 14 7.49805C14 7.76326 13.8946 8.01762 13.7071 8.20515C13.5196 8.39269 13.2652 8.49805 13 8.49805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.1b73fdf874bbb6156c8ba5e8207a8a50.svg";
export { ForwardRef as ReactComponent };